import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  private form: FormGroup;

  setForm(form: FormGroup): void {
    this.form = form;
  }

  getForm(): FormGroup {
    return this.form;
  }
}
